import invoice from './invoice'

export default {
  getDriver: store => ({
    invoice: invoice(store),
  }),
}
